import { Box, Typography } from '@mui/material';
import styles from '@styles/propertySearchPageStyles';
import {
  AVAILABLE_RECOMMENDED_PROPERTIES,
  RECENTLY_SOLD_OR_LET_RECOMMENDED_PROPERTIES
} from '@utils/Constants/propertySearchPageConstant';
import React from 'react';

export function MapRecommendedLegends() {
  return (
    <Box sx={styles.recommendedLegendsBox}>
      <Box sx={styles.legendTextIcon}>
        <img src="/mapImages/recommendedProperty.svg" alt="red circle" />
        <Typography variant="subtitle2" component="span">
          {AVAILABLE_RECOMMENDED_PROPERTIES}
        </Typography>
      </Box>
      <Box sx={styles.legendTextIcon}>
        <img
          src="/mapImages/recommendedPropertySoldLet.svg"
          alt="green circle"
        />
        <Typography variant="subtitle2" component="span">
          {RECENTLY_SOLD_OR_LET_RECOMMENDED_PROPERTIES}
        </Typography>
      </Box>
    </Box>
  );
}

export default MapRecommendedLegends;
